import { hookstate } from '@hookstate/core'

const globalDataDashboardSurveyStore = hookstate({
});

export default globalDataDashboardSurveyStore;
